import { IRequestParams, request } from './request';
import {
  AddToCartAPI,
  GetArtistGroupsAPI,
  GetArtistMembersAPI,
  GetBannersAPI,
  GetCartAPI,
  GetCartOffersAPI,
  GetPhotocardsAPI,
  GetPickupTimeAPI,
  RemoveFromCartAPI
} from '@/types/main';
import { ShippingCountryType } from '@/types/order';

export const getArtistGroups = (q?: string) =>
  request<GetArtistGroupsAPI.Request, GetArtistGroupsAPI.Response>({
    url: `/card/kiosk/v1/group`,
    method: 'GET',
    params: q && q.trim() ? { q } : undefined
  });

export const getCartOffers = (accessToken?: string) =>
  request<GetCartOffersAPI.Request, GetCartOffersAPI.Response>({
    url: `/collection/kiosk/v1/cart`,
    method: 'GET',
    token: accessToken
  });

export const getArtistMembers = (groupId: number) =>
  request<GetArtistMembersAPI.Request, GetArtistMembersAPI.Response>({
    url: `/card/gb/v1/group/${groupId}/member?kiosk=true`,
    method: 'GET'
  });

export const getPhotocards = (options: IRequestParams<GetPhotocardsAPI.Request>) =>
  request<GetPhotocardsAPI.Request, GetPhotocardsAPI.Response>({
    url: `/card/kiosk/v1/search`,
    method: 'GET',
    ...options
  });

export const getCart = (accessToken?: string, couponCode?: string, receivingMethod?: string) =>
  request<GetCartAPI.Request, GetCartAPI.Response>({
    url: `/collection/kiosk/v1/cart`,
    method: 'GET',
    token: accessToken,
    params: { coupon_code: couponCode ?? '', receiving_method: receivingMethod ?? '' }
  });

export const addToCart = (offerId: number, accessToken?: string) =>
  request<AddToCartAPI.Request, AddToCartAPI.Response>({
    url: `/collection/kiosk/v1/cart`,
    method: 'POST',
    token: accessToken,
    params: { offer_id: offerId }
  });

export const removeFromCart = (offerList: number[], accessToken?: string) =>
  request<RemoveFromCartAPI.Request, RemoveFromCartAPI.Response>({
    url: `/collection/kiosk/v1/cart`,
    method: 'DELETE',
    token: accessToken,
    params: { offer_list: offerList }
  });

export const getShippingCountries = (accessToken?: string) =>
  request<undefined, { countries: ShippingCountryType[] }>({
    url: `/collection/kiosk/v1/shipping/countries`,
    method: 'GET',
    token: accessToken
  });

export const deleteCache = (accessToken?: string) =>
  request({
    url: `/payment/kiosk/v1/clear-cache`,
    method: 'POST',
    token: accessToken
  });

export const getPickupTime = (accessToken?: string, pickupLocation?: string) =>
  request<GetPickupTimeAPI.Request, GetPickupTimeAPI.Response>({
    url: `/office/kiosk/pickup-time`,
    method: 'GET',
    token: accessToken,
    params: { pickup_location: pickupLocation }
  });

export const postStaffHelp = (kioskName: string, accessToken?: string) =>
  request<
    {
      kiosk_name: string;
    },
    AddToCartAPI.Response
  >({
    url: `/collection/kiosk/v1/help`,
    method: 'POST',
    token: accessToken,
    params: { kiosk_name: kioskName }
  });

export const getHomeBanners = (accessToken?: string) =>
  request<
    {
      kiosk_name: string;
    },
    GetBannersAPI.Response
  >({
    url: `/home/v1/kiosk/banners`,
    method: 'GET',
    token: accessToken
  });
